import { BaseService } from '@app/core/services/base-service.service';
import { GenericMemberResponsePortalResponseDto } from '@app/core/models/genericMembeResponsePortalResponseDto';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MemberResponsePortalResponseDto } from '@app/core/models/memberResponsePortalResponseDto';
import { Observable } from 'rxjs';
import { SubmitSurveyRequestDto } from '../model/submitSurveyRequestDto';
import { SurveySummaryDto } from '../model/surveySummaryDto';


@Injectable({
  providedIn: 'root',
})
export class SummaryService extends BaseService {
  //#region Constructor
  constructor(http: HttpClient) {
    super(http);
  }
  //#endregion Constructor

  //#region Public Methods
  public GetSummaryById(SurveyId: number): Observable<GenericMemberResponsePortalResponseDto<SurveySummaryDto>> {
    return this.Get(`/Survey/${SurveyId}/Summary`) as Observable<GenericMemberResponsePortalResponseDto<SurveySummaryDto>>;
  }

  public Save(summaryDto: SubmitSurveyRequestDto): Observable<GenericMemberResponsePortalResponseDto<MemberResponsePortalResponseDto>> {
    return this.Post('/Survey', summaryDto);
  }
  //#endregion Public Methods
}
